import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";

function SubjectItemHead() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      id: 0,
      name: "",
      createdBy: localStorage.getItem("userId"),
      organizationId: organizationId,
    },
  });

  const [subjectItemHead, setSubjectItemHead] = useState([]);
  const fetchSubjectItemHead = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllEvaluationSubjectItemHead?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSubjectItemHead(response.evaluationTypes);
    } catch (error) {
      console.error("Error fetching subject:", error);
    }
  };
  useEffect(() => {
    fetchSubjectItemHead();
  }, [triggerRerender]);

  const filteredSubjectItemHead = subjectItemHead.filter((item) =>
    item.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Item Head",
      selector: (row) => row.description,
      sortable: true,
      width: "400px",
    },
    // {
    //   name: "Comments",
    //   selector: (row) => row.comments,
    //   sortable: true,
    // },
    {
      name: "Action",
      width: "70px",
      selector: (row) => (
        <div className="d-flex gap-1">
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleEditClick(row.id)}
          >
            <i className="fas fa-pencil"></i>
          </button>
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const handleEditClick = async (rowId) => {
    const response = await get(
      `StudentEvaluation/GetEvaluationSubjectItemHeadById?id=${rowId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const subjectItemHead = response.subjectItemHead;

    reset({
      id: subjectItemHead.id,
      description: subjectItemHead.description,
      organizationId: subjectItemHead.organizationId,
      comments: subjectItemHead.comments,
      createdBy: subjectItemHead.createdBy,
      updatedBy: localStorage.getItem("userId"),
    });
  };
  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Item Head?"
    );

    if (confirmDelete) {
      try {
        const response = await get(
          `StudentEvaluation/DeleteEvaluationSubjectItemHeadById?id=${rowId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        fetchSubjectItemHead();
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };
  const saveData = async (data) => {
    data.statusId = 1;
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(
        "StudentEvaluation/AddEvaluationSubjectItemHeadAsync",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        reset({
          id: 0,
          description: "",
          comments: "",
          organizationId: organizationId,
          createdBy: localStorage.getItem("userId"),
          updatedBy: localStorage.getItem("userId"),
        });
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Subject Item Head</h2>
      </div>
      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-2">
                <div className="col-md-4">
                  <label className="form-label">
                    Item Head<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`description`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.description && (
                    <small className="text-danger">
                      {errors.description.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Comments<span className="text-danger fs-9"></span>
                  </label>
                  <input
                    {...register(`comments`)}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                </div>
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div
                className="d-flex justify-content-end"
                style={{ marginTop: 0 }}
              >
                <div className="d-flex align-items-start gap-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </div>
              </div>

              <DataTable
                columns={columns}
                data={filteredSubjectItemHead}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default SubjectItemHead;
